import { I18n } from '@calendly/i18n'

import { getOptions } from './get_options'

const getBufferTimes = () => {
  const bufferTimes = {}

  getOptions().forEach((option, index) => {
    if (index === 0) return // Skip for 0 mins

    bufferTimes[option.value] = option.name
  })

  return bufferTimes
}

// i18n-tasks-use t('publisher.event_type_editor.sections.scheduling_settings.event_limits.buffer.before')
// i18n-tasks-use t('publisher.event_type_editor.sections.scheduling_settings.event_limits.buffer.after')
const convertBufferToText = (bufferTime, beforeOrAfter) => {
  const bufferTimes = getBufferTimes()
  const time = bufferTimes[bufferTime]

  if (!time) return null
  if (!beforeOrAfter) return time

  return I18n.t(
    `publisher.event_type_editor.sections.scheduling_settings.event_limits.buffer.${beforeOrAfter}`,
    { time }
  )
}

export const getSummary = (beforeBuffer, afterBuffer) => {
  const beforeText = convertBufferToText(beforeBuffer, 'before')
  const afterText = convertBufferToText(afterBuffer, 'after')

  const buffers = [beforeText, afterText].filter((text) => text)

  if (buffers.length === 0) {
    return I18n.t('publisher.event_type_editor.sections.scheduling_settings.event_limits.buffer.none')
  }

  if (beforeBuffer === afterBuffer) {
    return I18n.t('publisher.event_type_editor.sections.scheduling_settings.event_limits.buffer.before_and_after',
      { time: convertBufferToText(beforeBuffer) })
  }

  return buffers.join(', ')
}
